import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { trackGAEvent } from 'Actions/adsActions';
import { showGallery } from 'Actions/PhotoGalleryActions';

class PhotoSwipeGallery extends React.Component {
	static propTypes = {
		items: PropTypes.object.isRequired,
		options: PropTypes.object
	};

	thumbnailContent = (item) => {
		return (
			<img src={item.src} />
		);
	};

	showPhotoSwipe = (itemIndex,postId) => {
		return (e) => {
			e.preventDefault();
			let options = this.props.options;
			options.index = itemIndex;
			options.getThumbBoundsFn = (index) => {
				let thumbnail = ReactDOM.findDOMNode(this.refs['thumbnail' + index]);
				let img = thumbnail.getElementsByTagName('img')[0];
				let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
				let rect = img.getBoundingClientRect();
				return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
			};
			this.props.dispatch(showGallery(options,postId));
			// Record the Google Analytics event.
			this.props.dispatch(trackGAEvent( false, 'open', 'uiAction', 'mediaViewer'));
		};
	};

	render() {
		return (
			<div className='pswp-gallery postFooter'>
				<div className="title">Attachments</div>
				<ul className='pswp-thumbnails'>
					{this.props.attachments().map((item) => {
						return (
							<li key={item.index} ref={'thumbnail' + item.index}
								className='pswp-thumbnail attachmentItem'
								onClick={this.showPhotoSwipe(item.index, this.props.postId)}>
								{this.thumbnailContent(item)}
							</li>
						);
					})}
				</ul>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		isOpen: state.photogallery.isOpen,
		items: state.photogallery.items,
		options: state.photogallery.options
	};
}

export default connect(mapStateToProps)( PhotoSwipeGallery );



// WEBPACK FOOTER //
// ./src/components/common/PhotoSwipeGallery.js